import { observable, computed, toJS, makeObservable } from 'mobx'
import { type Photo } from 'components/PhotoBank/PhotoBank.types'
import {
  type CollagePhotoPosition,
  type CropperData,
} from '../TilesStore.types'
import type { CollagePhotoSlotData, TileCrop } from './tileSchemas'
import type { PhotoBankStore } from '../../photoBankStore/PhotoBankStore'

export class CollagePhotoSlot {
  @observable accessor uid: string | undefined

  @observable.deep accessor position: CollagePhotoPosition | undefined

  @observable.deep accessor cropParams: Record<number, TileCrop>

  @observable.deep accessor cropperData: Record<number, CropperData>

  private readonly photoBankStore: PhotoBankStore

  constructor(data: CollagePhotoSlotData, photoBankStore: PhotoBankStore) {
    this.photoBankStore = photoBankStore
    this.uid = data.uid
    this.position = data.position
    this.cropParams = data.cropParams
    this.cropperData = data.cropperData as Record<number, CropperData>
    makeObservable(this)
  }

  @computed
  get photo(): Photo | undefined {
    return this.uid ? this.photoBankStore.getPhoto(this.uid) : undefined
  }

  @computed
  get isLocal(): boolean {
    return this.photo?.isLocal ?? false
  }

  @computed
  get url(): string | undefined {
    return this.photo?.url
  }

  @computed
  get minimalResUrl(): string | undefined {
    return this.photo?.minimalResUrl
  }

  @computed
  get lowResUrl(): string | undefined {
    return this.photo?.lowResUrl
  }

  @computed
  get highResUrl(): string | undefined {
    return this.photo?.highResUrl
  }

  @computed
  get width(): number {
    return this.photo?.width ?? 0
  }

  @computed
  get height(): number {
    return this.photo?.height ?? 0
  }

  toJSON(): Record<string, unknown> {
    return {
      uid: this.uid,
      position: toJS(this.position),
      cropParams: toJS(this.cropParams),
      cropperData: toJS(this.cropperData),
    }
  }
}
